import React from 'react';
import styled, { css } from 'styled-components';
import { ServiceTypes } from 'utils/constants/venues';
import PillSelectBox from '../../../../MenuEditor/components/shared/PillSelectBox';

const Container = styled.div`
  width: 100px;
  display: inline-block;

  & > label {
    color: #797979;
    letter-spacing: -0.2px;
  }

  ${props => {
    if (props.variant === 'OptionsField') {
      return css`
        width: 77px;
        margin-right: 10px;

        & > label {
          display: inline-block;
          padding-bottom: 10px;
        }
      `;
    }
  }}
`;

function ServiceTypeSelect(props) {
  return (
    <Container variant={props.variant}>
      <PillSelectBox
        noMargin={true}
        id={props.id}
        value={
          props.value === '' ? ServiceTypes.TABLE_AND_COLLECTION : props.value
        }
        variant={props.variant}
        disabled={props.disabled || false}
        onChange={e => props.onChange(e)}
      >
        <option
          className="select-box__option"
          value={ServiceTypes.TABLE_AND_COLLECTION}
        >
          Table Service + Collection
        </option>
        <option className="select-box__option" value={ServiceTypes.TABLE_ONLY}>
          Table Service Only
        </option>
        <option
          className="select-box__option"
          value={ServiceTypes.COLLECTION_ONLY}
        >
          Collection Only
        </option>
      </PillSelectBox>
    </Container>
  );
}

export default ServiceTypeSelect;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/components/GroupEditor/ServiceTypeSelect/index.jsx